import { Reducer } from "redux";

import { NotesTemplateJsonResp } from "../models/Api/Notes";
import { EditableDisciplineNotesTemplateDispatchTypes } from "../models/DispatchTypes/Notes";
import { GetEditableDisciplineNotesTemplateActionDispatchTypes } from "../constants/Notes";

export const initialState: NotesTemplateJsonResp = {
  loading: false,
  response: {
    noteTemplateId: -1,
    templateName: "",
    templateJson: "",
    templateCategoryId: "",
    categoryName: "",
  },
};

const EditableDisciplineNotesTemplateJsonReducer: Reducer<
  NotesTemplateJsonResp,
  EditableDisciplineNotesTemplateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetEditableDisciplineNotesTemplateActionDispatchTypes.EDITABLE_DISCIPLINE_NOTES_TEMPLATE_JSON_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetEditableDisciplineNotesTemplateActionDispatchTypes.EDITABLE_DISCIPLINE_NOTES_TEMPLATE_JSON_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetEditableDisciplineNotesTemplateActionDispatchTypes.EDITABLE_DISCIPLINE_NOTES_TEMPLATE_JSON_RESET: {
      return initialState;
    }
  }
  return state;
};

export default EditableDisciplineNotesTemplateJsonReducer;
